export const CONTENT_MANAGER_MOCK_DATA = {
	plans: [
		{
			title: 'Get Your Movement Credit Score',
			planType: "screening",
			description: `<p>Movement and posture screening to assess your flexibility.</p>
				<p>Tailored report with personal insights.</p>
				<p>Recommendations to improve your score.</p>`,
			thumbnail: 'https://develop.carespace.ai/images/dashboard/card-1.jpg',
		},
		{
			title: 'Commit to Prevention and Early Intervention',
			planType: "earlyIntervention",
			description: `<p>All movement credit score features.</p>
				<p>Tailored Let’s Move programming to improve flexibility + strength + endurance.</p>
				<p>Personalized recommendations and training guides.</p>`,
			thumbnail: 'https://develop.carespace.ai/images/dashboard/card-2.jpg',
		},
		{
			title: 'Recover and Rejuvenate with Virtual Support',
			planType: "virtualPt",
			description: `<p>Virtual evaluation.</p>
				<p>Assignment of personalized care plan for recovery Asynchronous guided </p>
				<p>Let’s Move rehab sessions Virtual monitoring of activity with 1:1 support and communication </p>
				<p>Movement and posture screening </p>
				<p>Tailored health assessments and reports</p>`,
			thumbnail: 'https://develop.carespace.ai/images/dashboard/card-3.jpg',
		},
	],
	preExistingConditions: {
		title:
			'I acknowledge I do not have any of the criteria listed above and am eligible to participate in this program.',
		description: `<p>1. Are there any pre-existing conditions or recent surgical procedures that impact your current functional movement?</p>
			<p>2. Do you have balance issues?</p>
			<p>3. Are you enrolled in any existing physical therapy program?</p>
			<p>4. Are you experiencing any joint discomfort that affects your mobility?</p>`,
		thumbnail: 'https://demo.carespace.ai/images/PreExistingCondition.png',
	},
	goals: [
		{
			title: 'Managing Discomfort',
			functionalGoalId: 1,
			description: `<p>Ease discomfort with rest, breathing, or movement to reduce stress and feel better</p>`,
			thumbnail:
				'https://demo.carespace.ai/images/dashboard/FunctionalCard.jpg',
		},
		{
			title: 'Functional Independence & Daily Living',
			functionalGoalId: 2,
			description: `<p>Restore ROM, Strength, and Endurance Post-Injury, Pre/Post-Surgical Rehabilitation.</p>`,
			thumbnail:
				'https://demo.carespace.ai/images/dashboard/FunctionalGoalCard-2.png',
		},
		{
			title: 'Performance Enhancement',
			functionalGoalId: 3,
			description: `<p>Injury Prevention, Sports-Specific Training & Performance Optimization.</p>`,
			thumbnail:
				'https://demo.carespace.ai/images/dashboard/FunctionalGoalCard-6.png',
		},
		{
			title: 'Injury Prevention',
			functionalGoalId: 6,
			description: `<p>Improve strength, flexibility, balance, and movement control.</p>`,
			thumbnail:
				'https://demo.carespace.ai/images/dashboard/FunctionalGoalCard-7.jpg',
		},
		{
			title: 'Holistic Well-being & Quality of Life',
			functionalGoalId: 7,
			description: `<p>Improve Overall Wellness & Stress Management, Enhance Quality of Life, Improve Cardiovascular and Respiratory Function, Weight Management.</p>`,
			thumbnail:
				'https://demo.carespace.ai/images/dashboard/FunctionalGoalCard-10.png',
		},
	],
};

export const PLAN_TYPES = ['screening', 'earlyIntervention', 'virtualPt'];

export const FUNCTIONAL_GOAL_IDS = [1, 2, 6, 7, 10];
